import { addStream } from '../../epicStore'
import { map, tap } from 'rxjs/operators'
import { afterAllTypes, pluckFrom } from '../../../../lib/observables'
import * as actionTypes from '../../../constants/actionTypes'
import { DocsType } from '../../../actions/docs/docsTypes'
import actions from '../../../actions/slides'
import SlidesEventsObservable from './SlidesEventsObservable'

const addSlidesEvents$ = (actions$, state, { getUpdatedValues }) => actions$.pipe(
  afterAllTypes(DocsType.SET_SLIDES_DOCUMENT, actionTypes.SET_ROLE),
  pluckFrom(DocsType.SET_SLIDES_DOCUMENT),
  map(doc => SlidesEventsObservable(doc, getUpdatedValues)),
  tap(stream$ => addStream(stream$)),
  map(() => actions.listenersAdded())
)

export default addSlidesEvents$
